
import React from 'react';
import AnimatedSection from './AnimatedSection';
import SectionHeading from './SectionHeading';
import { Folder, Github, ExternalLink } from 'lucide-react';

const projects = [
  {
    title: 'GPUForge',
    description: 'A Kubernetes-native GPU infrastructure platform for multi-tenant LLM inference and distributed training. It turns GPU capacity into a self-service platform through CRDs, APIs, scheduling, observability, and cost attribution.',
    tags: ['Go', 'Kueue', 'NVIDIA GPU Operator', 'vLLM', 'Helm'],
  },
  {
    title: 'LLM-D',
    description: 'A technical research prototype for disaggregated LLM inference. It explores prefill/decode separation, KV-cache lifecycle, GPU memory pressure, and the network paths behind distributed inference.',
    tags: ['LLM Inference', 'KV Cache', 'NVLink', 'RDMA', 'Kubernetes'],
  },
  {
    title: 'Platform Operations Assistant',
    description: 'An AI-powered operations assistant that routes natural-language investigations across CI/CD, pipeline logs, SonarQube, documentation, and platform signals with durable state and checkpoint recovery.',
    tags: ['LangGraph', 'Azure OpenAI', 'RAG', 'PostgreSQL', 'Agentic AI'],
  },
  {
    title: 'Security Remediation Agent',
    description: 'An AI-assisted security workflow integrated with GitHub that identifies vulnerabilities and generates remediation pull requests, bringing the fix closer to the signal.',
    tags: ['GitHub', 'Azure OpenAI', 'Security', 'Automation'],
  },
];

export default function Projects() {
  return (
    <AnimatedSection id="projects">
      <SectionHeading number={4}>Some Things I’ve Built</SectionHeading>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {projects.map((p, i) => (
          <div key={i} className="p-7 rounded-xl flex flex-col transition-all duration-300 hover:-translate-y-2 group" style={{ background:'rgba(15,23,42,0.7)', border:'1px solid rgba(30,41,59,0.7)', backdropFilter:'blur(8px)', boxShadow:'0 4px 24px rgba(0,0,0,0.35)' }} onMouseEnter={e=>{e.currentTarget.style.borderColor='rgba(45,212,191,0.2)';e.currentTarget.style.boxShadow='0 8px 32px rgba(0,0,0,0.4),0 0 0 1px rgba(45,212,191,0.08)'}} onMouseLeave={e=>{e.currentTarget.style.borderColor='rgba(30,41,59,0.7)';e.currentTarget.style.boxShadow='0 4px 24px rgba(0,0,0,0.35)'}}>
            <div className="flex justify-between items-center mb-6">
              <Folder className="w-10 h-10 text-teal-300" />
              <div className="flex gap-3">
                <a href="https://github.com/AshwinSridharan0410" className="text-slate-400 hover:text-teal-300 transition-colors"><Github size={20}/></a>
                <a href="https://github.com/AshwinSridharan0410" className="text-slate-400 hover:text-teal-300 transition-colors"><ExternalLink size={20}/></a>
              </div>
            </div>
            <h3 className="text-lg font-bold text-slate-100 mb-2">{p.title}</h3>
            <p className="text-slate-400 text-sm flex-grow mb-6">{p.description}</p>
            <div className="flex flex-wrap gap-2 font-mono text-xs">
              {p.tags.map(tag => <span key={tag} className="px-2 py-0.5 rounded" style={{ color:'rgba(94,234,212,0.8)', background:'rgba(45,212,191,0.07)', border:'1px solid rgba(45,212,191,0.12)' }}>{tag}</span>)}
            </div>
          </div>
        ))}
      </div>
    </AnimatedSection>
  );
}
